import { SearchOutlined } from '@ant-design/icons'
import { CORE_CONSTANT, type ViewConfigDimension } from '@salescore/core'
import { Select, Tag } from 'antd'
import { Array, Order, pipe } from 'effect'
import { t } from 'i18next'

export const DimensionsPickerSelect = ({
  dimensions,
  pickedDimensions,
  placeholder,
  onChange,
}: {
  dimensions: ViewConfigDimension[]
  pickedDimensions: ViewConfigDimension[]
  placeholder?: string
  onChange: (values: string[]) => void
}) => {
  const options = pipe(
    dimensions,
    Array.filter(
      (x) =>
        x.fieldType === 'string' || x.fieldType === 'date' || x.fieldType === 'datetime' || x.fieldType === 'boolean',
    ),
    Array.sortBy(Order.mapInput(Order.Number, (x) => -(x.dimensionCount ?? 0))),
    Array.map((x) => ({
      value: x.key,
      key: [x.key, x.label].join(' '),
      label: x.label,
      // count: (x.dimensionCount ?? 0) > 1 ? x.dimensionCount : undefined,
      // eslint-disable-next-line sonarjs/no-nested-conditional
      tags: x.type === 'dimensionGroup' ? [t(`軸グループ`)] : isKpiDimension(x) ? [t(`KPI設定`)] : undefined,
    })),
  )

  return (
    <Select
      showSearch
      mode="multiple"
      filterOption={
        // eslint-disable-next-line @typescript-eslint/no-unsafe-type-assertion
        (input, option) => ((option?.key ?? '') as string).toLowerCase().includes(input.toLowerCase())
      }
      tagRender={(properties) => {
        if (properties.value === pickedDimensions[0]?.key) {
          return (
            <div style={{ color: '#bfbfbf', paddingLeft: 7, top: 3 }} className="absolute">
              {placeholder ?? `${t(`項目を追加`)}…`}
              <br />
            </div>
          )
        }
        return <></>
      }}
      onChange={(values) => {
        onChange(values)
      }}
      value={pickedDimensions.map((x) => x.key)}
      placeholder={`${t(`項目を追加`)}…`}
      suffixIcon={<SearchOutlined />}
      className="w-full"
    >
      {pipe(
        options,
        Array.dedupeWith((a, b) => a.value === b.value),
        Array.map((option) => (
          <Select.Option value={option.value} key={option.key}>
            <div className="py-1">
              <span className="mr-1 whitespace-pre-wrap break-words">{option.label}</span>
              {(option.tags ?? []).map((tag, index) => (
                <Tag key={`${tag}_${index}`} className="ml-1">
                  {tag}
                </Tag>
              ))}
            </div>
          </Select.Option>
        )),
      )}
    </Select>
  )
}

function isKpiDimension(x: ViewConfigDimension) {
  return (
    [CORE_CONSTANT.KPI_PIVOT_KPI_DATE_DIMENSION().key, CORE_CONSTANT.KPI_PIVOT_USER_DIMENSION().key].includes(x.key) ||
    x.key.includes(`salescore_user_group`)
  )
}
